
import OrderTable from "../Table";

const Rejected = () => {
  return <OrderTable type="Rejected" />;
};

export default Rejected;
